import { render, staticRenderFns } from "./CveVersionTableCell.vue?vue&type=template&id=9541cd40&scoped=true"
import script from "./CveVersionTableCell.vue?vue&type=script&lang=js"
export * from "./CveVersionTableCell.vue?vue&type=script&lang=js"
import style0 from "./CveVersionTableCell.vue?vue&type=style&index=0&id=9541cd40&prod&lang=scss"
import style1 from "./CveVersionTableCell.vue?vue&type=style&index=1&id=9541cd40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9541cd40",
  null
  
)

export default component.exports